import { renderIcon, type IconKey } from './icons';

export type QuickAccessTileProps = {
  id: string;
  label: string;
  icon: IconKey;
};

function QuickAccessTile({ id, label, icon }: QuickAccessTileProps) {
  return (
    <a className="axi-quick-tile" href={`#${id}`}>
      <span className="axi-quick-tile__icon">{renderIcon(icon, 28)}</span>
      <span className="axi-quick-tile__label">{label}</span>
    </a>
  );
}

export default QuickAccessTile;